__turbopack_context__.v({
  "bar": "Progress-module__-_MOCG__bar",
  "error": "Progress-module__-_MOCG__error",
  "indeterminate": "Progress-module__-_MOCG__indeterminate",
  "info": "Progress-module__-_MOCG__info",
  "lg": "Progress-module__-_MOCG__lg",
  "md": "Progress-module__-_MOCG__md",
  "progress-sweep": "Progress-module__-_MOCG__progress-sweep",
  "root": "Progress-module__-_MOCG__root",
  "sm": "Progress-module__-_MOCG__sm",
  "success": "Progress-module__-_MOCG__success",
  "warning": "Progress-module__-_MOCG__warning",
});
